'use strict';

if (process.env.NODE_ENV === "production") {
  module.exports = require("./emotion-utils.cjs.prod.js");
} else {
  module.exports = require("./emotion-utils.cjs.dev.js");
}



//////////////////
// WEBPACK FOOTER
// ./~/@emotion/utils/dist/emotion-utils.cjs.js
// module id = 157
// module chunks = 0